// extracted by mini-css-extract-plugin
export default {"newsBarContainer":"newsBarContainer-Y2LXR","newsBarInner":"newsBarInner-NZMGP","newsBarHeader":"newsBarHeader-hw9o7"};